import { ROUTES } from '@/constants/routes';

const FALLBACK_ORIGIN = 'http://localhost';

export function getPostLoginRedirectPath(
  search: string,
  fallbackPath: string = ROUTES.DASHBOARD_AI_AGENTS
) {
  const requestedPath = new URLSearchParams(search).get('redirect_uri');
  if (!requestedPath) return fallbackPath;

  try {
    const origin =
      typeof window === 'undefined' ? FALLBACK_ORIGIN : window.location.origin;
    const redirectUrl = new URL(requestedPath, origin);
    const isDashboardPath =
      redirectUrl.pathname === ROUTES.DASHBOARD_BASE ||
      redirectUrl.pathname.startsWith(`${ROUTES.DASHBOARD_BASE}/`);

    if (redirectUrl.origin !== origin || !isDashboardPath) {
      return fallbackPath;
    }

    return `${redirectUrl.pathname}${redirectUrl.search}${redirectUrl.hash}`;
  } catch {
    return fallbackPath;
  }
}

export function withPostLoginRedirect(route: string, redirectPath: string) {
  const search = new URLSearchParams({ redirect_uri: redirectPath });
  return `${route}?${search.toString()}`;
}
